const IMAGE_QUERY_PARAMS = '?w=300&bg=F5F6F7&fm=jpeg&auto=format';
const errorsMapping = {
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong'
};

export { IMAGE_QUERY_PARAMS, errorsMapping };
//# sourceMappingURL=constants.js.map
